import { useState } from "react";
import Button from "../../../../componentes/button/button";
import ProdutoAutoComplete from "../shared/ProdutoAutoComplete";
import SelecionarVeiculoModal from "../shared/SelecionarVeiculoModal";

export default function ProdutoEditor({ itens = [], onChange, exigeVeiculo = false }) {
    const [indiceEscolhendoVeiculo, setIndiceEscolhendoVeiculo] = useState(null);

    function atualizarItem(index, campo, valor) {
        onChange(itens.map((item, i) => i === index ? { ...item, [campo]: valor } : item));
    }

    function atualizarProduto(index, produto) {
        onChange(itens.map((item, i) => i === index ? {
            ...item,
            produtoCatalogoId: produto?.id ?? null,
            produtoCatalogoNome: produto?.nome ?? "",
            unidadeMedida: produto?.unidadeMedida ?? "",
        } : item));
    }

    function selecionarVeiculo(veiculo) {
        onChange(itens.map((item, i) => i === indiceEscolhendoVeiculo ? {
            ...item,
            placaVeiculo: veiculo.placa,
            veiculoLabel: `${veiculo.placa}${veiculo.modelo ? ` · ${veiculo.modelo}` : ""}`,
        } : item));
        setIndiceEscolhendoVeiculo(null);
    }

    function removerVeiculo(index) {
        onChange(itens.map((item, i) => i === index ? { ...item, placaVeiculo: null, veiculoLabel: "" } : item));
    }

    function adicionar() {
        onChange([...itens, {
            produtoCatalogoId: null,
            produtoCatalogoNome: "",
            unidadeMedida: "",
            quantidade: 1,
            detalhes: "",
            placaVeiculo: null,
            veiculoLabel: "",
            anexo: null,
        }]);
    }

    function remover(index) {
        onChange(itens.filter((_, i) => i !== index));
    }

    function selecionarAnexo(index, evento) {
        const arquivo = evento.target.files?.[0] ?? null;
        evento.target.value = "";
        if (arquivo) atualizarItem(index, "anexo", arquivo);
    }

    const gridCols = exigeVeiculo
        ? "sm:grid-cols-[2fr_90px_90px_2.5fr_1.2fr_auto]"
        : "sm:grid-cols-[2fr_90px_90px_2fr_auto]";

    return (
        <div className="flex flex-col gap-2">
            {itens.map((item, index) => (
                <div key={index} className="flex flex-col gap-2 bg-muted rounded-lg p-3">
                    <div className={`grid grid-cols-1 ${gridCols} gap-2 items-end`}>
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-medium text-foreground/80">Produto</label>
                            <ProdutoAutoComplete
                                value={item.produtoCatalogoId ? { id: item.produtoCatalogoId, nome: item.produtoCatalogoNome } : null}
                                onChange={produto => atualizarProduto(index, produto)}
                            />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-medium text-foreground/80">Quantidade</label>
                            <input
                                type="number"
                                min="1"
                                value={item.quantidade}
                                onChange={e => atualizarItem(index, "quantidade", e.target.value)}
                                className="w-full h-9 px-3 text-sm border border-input rounded-lg bg-card outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
                            />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-medium text-foreground/80">Unidade</label>
                            <div className="w-full h-9 px-3 flex items-center text-sm text-muted-foreground border border-transparent rounded-lg">
                                {item.unidadeMedida || "—"}
                            </div>
                        </div>
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-medium text-foreground/80">Detalhes <span className="text-destructive">*</span></label>
                            <input
                                type="text"
                                value={item.detalhes}
                                onChange={e => atualizarItem(index, "detalhes", e.target.value)}
                                className="w-full h-9 px-3 text-sm border border-input rounded-lg bg-card outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
                            />
                        </div>
                        {exigeVeiculo && (
                            <div className="flex flex-col gap-1">
                                <label className="text-xs font-medium text-foreground/80">Veículo <span className="text-destructive">*</span></label>
                                {item.placaVeiculo ? (
                                    <div className="flex items-center gap-2 h-9 px-3 text-xs bg-primary/10 text-primary rounded-lg">
                                        <span className="truncate" title={item.veiculoLabel || item.placaVeiculo}>
                                            {item.veiculoLabel || item.placaVeiculo}
                                        </span>
                                        <button
                                            type="button"
                                            title="Trocar veículo"
                                            onClick={() => removerVeiculo(index)}
                                            className="ml-auto shrink-0 hover:text-destructive"
                                        >
                                            <i className="fa fa-times" />
                                        </button>
                                    </div>
                                ) : (
                                    <Button variant="white" label="Selecionar veículo" onClick={() => setIndiceEscolhendoVeiculo(index)} />
                                )}
                            </div>
                        )}
                        <button
                            type="button"
                            title="Remover produto"
                            onClick={() => remover(index)}
                            className="h-9 w-9 flex items-center justify-center rounded-full text-destructive hover:bg-destructive/10"
                        >
                            <i className="fa fa-trash" />
                        </button>
                    </div>

                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-foreground/80">Imagem do Produto</label>
                        {item.anexo ? (
                            <div className="flex items-center gap-2 h-9 px-3 text-xs bg-primary/10 text-primary rounded-lg w-full sm:w-64">
                                <i className="fa fa-paperclip shrink-0" />
                                <span className="truncate flex-1" title={item.anexo.name}>{item.anexo.name}</span>
                                <button
                                    type="button"
                                    title="Remover anexo"
                                    onClick={() => atualizarItem(index, "anexo", null)}
                                    className="shrink-0 hover:text-destructive"
                                >
                                    <i className="fa fa-times" />
                                </button>
                            </div>
                        ) : (
                            <label className="flex items-center justify-center gap-1.5 h-9 px-3 w-full sm:w-64 text-xs border border-dashed border-border rounded-lg cursor-pointer text-muted-foreground hover:border-primary/50 hover:bg-muted">
                                <i className="fa fa-paperclip" />
                                Anexar arquivo/imagem
                                <input
                                    type="file"
                                    accept="image/*,.pdf"
                                    className="hidden"
                                    onChange={evento => selecionarAnexo(index, evento)}
                                />
                            </label>
                        )}
                    </div>
                </div>
            ))}
            <div>
                <Button variant="outline" label="Adicionar produto" iconLeft="fa fa-plus" onClick={adicionar} />
            </div>

            <SelecionarVeiculoModal
                isOpen={indiceEscolhendoVeiculo !== null}
                onClose={() => setIndiceEscolhendoVeiculo(null)}
                onSelecionar={selecionarVeiculo}
            />
        </div>
    );
}
